const dateInputOptions = {
  autoOk: true,
  format: 'MM/DD/YYYY',
  keyboard: true,
  disableOpenOnEnter: true, // Enter submits form so should not open date picker
};


export default dateInputOptions;



// WEBPACK FOOTER //
// ./src/dateInputOptions.js